export default __webpack_public_path__ + "static/N0115-c4f612b2d323e9f6013126fab3280566.png";